import {
  Stack,
  useMediaQuery
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { Glasses, Timer } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  InfoTypography,
  TopicCardSignatureStack
} from "./TopicCardSignature.styles";
import type { TopicCardSignatureProps } from "./TopicCardSignature.types";

export function TopicCardSignature({
  color,
  created,
  isModified,
  readingTime,
  size,
  ...props
}: TopicCardSignatureProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();

  return (
    <TopicCardSignatureStack
      flexGrow={ 1 }
      { ...props }
    >

      {
        created ?
          <Stack
            alignItems={ "center" }
            direction={ "row" }
            gap={ "4px" }>
            <Timer
              size={ 24 }
              color={ color || theme.customColors.exploreCardText }
            />
            <InfoTypography color={ color || theme.customColors.exploreCardText }
              fontSize={ "14px" }
            >{ created }</InfoTypography>

            {
              isModified ?
                <InfoTypography color={ color || theme.customColors.exploreCardText }
                  fontSize={ size === "small" ? theme.spacing(1.4) : theme.spacing(2.1) }
                > {  "( " +  t("modified") + " )" } </InfoTypography> : null
            }
          </Stack> : null
      }

      {
        readingTime ?
          <Stack
            alignItems={ "center" }
            direction={ "row" }
            gap={ 1 }
          >
            <Glasses
              color={ color || theme.customColors.textWidget }
              size={ isMobile || size === "small" ? 15 : 20 }
            />
            <InfoTypography color={ color || theme.customColors.textWidget }
              fontSize={ size === "small" ? theme.spacing(1.75) : theme.spacing(2) }
            > { readingTime } </InfoTypography>
          </Stack> :
          null
      }
    </TopicCardSignatureStack>
  );

}
